import React from 'react';
import './Pagination.css';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  totalItems, 
  itemsPerPage, 
  onPageChange,
  onItemsPerPageChange 
}) => {
  const pages = [];
  const maxPagesToShow = 5;
  
  let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
  if (endPage - startPage + 1 < maxPagesToShow) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }
  for (let i = startPage; i <= endPage; i++) pages.push(i);

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="pagination-container">
      <div className="pagination-info">
        Affichage de {startItem} à {endItem} sur {totalItems} utilisateurs
      </div>
      
      <div className="pagination-controls">
        <div
          role="button"
          tabIndex={currentPage === 1 ? -1 : 0}
          className={`pagination-btn${currentPage === 1 ? ' disabled' : ''}`}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          onKeyDown={(e) => e.key === 'Enter' && currentPage > 1 && onPageChange(currentPage - 1)}
        >
          Précédent
        </div>
        
        {startPage > 1 && (
          <>
            <div role="button" tabIndex={0} className="pagination-number"
              onClick={() => onPageChange(1)}
              onKeyDown={(e) => e.key === 'Enter' && onPageChange(1)}
            >1</div>
            {startPage > 2 && <span className="pagination-ellipsis">...</span>}
          </>
        )}
        
        {pages.map(page => (
          <div
            key={page}
            role="button"
            tabIndex={0}
            className={`pagination-number${page === currentPage ? ' active' : ''}`}
            onClick={() => onPageChange(page)}
            onKeyDown={(e) => e.key === 'Enter' && onPageChange(page)}
          >
            {page}
          </div>
        ))}
        
        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
            <div role="button" tabIndex={0} className="pagination-number"
              onClick={() => onPageChange(totalPages)}
              onKeyDown={(e) => e.key === 'Enter' && onPageChange(totalPages)}
            >{totalPages}</div>
          </>
        )}
        
        <div
          role="button"
          tabIndex={currentPage === totalPages ? -1 : 0}
          className={`pagination-btn${currentPage === totalPages ? ' disabled' : ''}`}
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
          onKeyDown={(e) => e.key === 'Enter' && currentPage < totalPages && onPageChange(currentPage + 1)}
        >
          Suivant
        </div>
      </div>
      
      <div className="pagination-per-page">
        <label>Par page:</label>
        <select 
          value={itemsPerPage} 
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
    </div>
  );
};

export default Pagination;